<template>
  <div class="col-span-6">
    <label for="field.label" class="block 2xl:text-sm sm:text-2xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input type="password" @change="updateValue(field.key, $event.target.value)" class="mt-1 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full 2xl:text-sm sm:text-xl border-gray-300 rounded-md"/>
    </div>
    <p v-if="validation.msg !== ''" class="mt-2 2xl:text-sm sm:text-lg text-red-600" id="email-error">* {{validation.msg}}</p>
  </div>
</template>

<script>
export default {
  name: 'password-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    validation: {
      type: Object,
      required: false,
      default() {
        return {'msg': ''}
      }
    }
  },
  watch: {
  },
  methods: {
    updateValue(key, value) {
      this.$parent.updateValue(key, value)
    }
  }
}
</script>
